import React from 'react';
import { invalidateApiDataRequest, performApiRequest } from 'react-api-data';
import { compose } from 'recompose';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { ConnectionStatus, LinkVlanStatus, ResourceType, Roles, simulateStatusOptions } from 'constants/literals';

import { DropdownItem } from 'reactstrap';
import RolesChecker from './RolesChecker';

interface InProps {
    resourceId: string | number;
    resourceStatus: string;
    linkId: string;
    exchange: string;
    isDropdownItem?: boolean;
    resourceType?: string;
}

interface ConnectProps {
    onUpdateStatus: (label: string) => void;
}

const mapDispatchToProps = (dispatch: any, ownProps: InProps) => ({
    onUpdateStatus: (label: string) => {
        dispatch(
            performApiRequest('updateResourceStatus', {
                resourceId: get(ownProps, 'resourceId'),
                linkId: ownProps.linkId,
                resourceStatus: statusToSet(label, ownProps.resourceStatus),
                exchange: ownProps.exchange,
            })
        ).then(() => {
            if (ownProps.resourceType === ResourceType.link_vlan) {
                dispatch(
                    invalidateApiDataRequest('getLinkVlan', {
                        linkVlanUuid: ownProps.resourceId
                    })
                );
            }
        });
    }
});

const statusToSet = (simulate: string, resourceStatus: string) => {
    switch (simulate) {
        case simulateStatusOptions.deconfigurationSuccessful:
            return ConnectionStatus.deconfigured;
        case simulateStatusOptions.deconfigurationFailed:
        case simulateStatusOptions.configurationSuccessful:
            return ConnectionStatus.configured;
        default:
            return resourceStatus;
    }
};

const simulateOptions = (status: string) => {
    switch (status) {
        case ConnectionStatus.configured:
            return [simulateStatusOptions.deconfigurationSuccessful];
        case ConnectionStatus.deconfiguring:
            return [simulateStatusOptions.deconfigurationFailed, simulateStatusOptions.deconfigurationSuccessful];
        case ConnectionStatus.unconfigured:
        case ConnectionStatus.configuring:
        case ConnectionStatus.reconfiguring:
        case ConnectionStatus.deconfigured:
        case LinkVlanStatus.moving_to_quarantine:
        case LinkVlanStatus.quarantined:
        case LinkVlanStatus.moving_to_production:
            return [simulateStatusOptions.configurationSuccessful];
        default:
            return [];
    }
};

export default compose<InProps & ConnectProps, InProps>(connect(null, mapDispatchToProps))(
    ({ resourceStatus, onUpdateStatus }) => {
        const labels = simulateOptions(resourceStatus);

        return (
            <RolesChecker data-test="update-status-roles" roles={[Roles.admin, Roles.noc]}>
                {labels.map((label) => (
                    <DropdownItem onClick={() => onUpdateStatus(label)} data-test="resource-update-status-btn">
                        {label}
                    </DropdownItem>
                ))}
            </RolesChecker>
        );
    }
);